<thead>
<tr>
  <th class="valgt">
    <mat-checkbox (click)="endreAlle.emit()"
                  [indeterminate]="!alleValgt() && !ingenValgt()"
                  [checked]="alleValgt()"
                  matTooltip="{{'Velg alle eller ingen medlemmer'|translate}}"
                  class="e2e-toggle-alle"/>
  </th>
  <th>{{ "Epost"|translate }}</th>
  <th>{{ "Navn"|translate }}</th>
  <th>{{ "Mobilnummer"|translate }}</th>
  <th>{{ "Rolle"|translate }}</th>
  <th>{{ "Rolle startdato"|translate }}</th>
  <th>{{ "Tilgang"|translate }}</th>
  <th>{{ "Deltar som standard"|translate }}</th>
  <th>{{ "Signerer som standard"|translate }}</th>
</tr>
</thead>

